module.exports = __webpack_public_path__ + "img/earn-points-echo.44b01483.jpg";